<template>
  <v-form @submit.prevent="getActionMethod">
    <v-card>
      <vue-card-title
        :title="cardTitle"
        :subtitle="
          'Fill up the following form to action on client designation.'
        "
        :icon="$getIcon('mdiFileDocumentEdit')"
        closable
        @close="$emit('close')"
      >
      </vue-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row align="center" justify="center">
          <span class="red--text font-weight-bold">{{
            formValidator.getError("non_field_errors")
          }}</span>
          <v-col md="12" cols="12">
            <v-text-field
              v-model="formValues.name"
              label="Designation Name"
              placeholder="Designation Name"
              :error-messages="formValidator.getError('name')"
            ></v-text-field>
            <v-switch
              v-model="formValues.head_of_organization"
              :label="`Head of the Organization`"
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row no-gutters>
          <v-col class="text-right">
            <v-btn depressed @click="clearFields()">
              Clear
            </v-btn>
            <v-btn
              :disabled="Object.keys(formValidator.errors).length > 0"
              class="primary"
              type="submit"
            >
              {{ actionData && actionData.id ? "Update" : "Save" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  props: {
    cardTitle: {
      type: String,
      default: ""
    },
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          name: "",
          head_of_organization: false
        };
      }
    }
  },
  data() {
    return {
      formValues: {
        ...this.actionData,
        organization: this.$store.state.shell.currentOrganizationId
      },
      formValidator: new FormValidator()
    };
  },
  watch: {
    actionData(val) {
      if (val) {
        this.formValues = { ...val };
      }
    },
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
  },
  methods: {
    getActionMethod() {
      if (this.formValues.id) return this.updateClientDesignation();
      return this.createClientDesignation();
    },
    createClientDesignation() {
      const clientDesignationAPI = "/api/v1/crm/client-designation/";
      this.$axios
        .$post(clientDesignationAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated client designation!`,
            color: "green"
          });
          this.$emit("clientDeisgnationFormResponse", "created");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
          this.$store.dispatch("shell/showSnackbar", {
            text: error.response.data.field_errors[0],
            color: "red"
          });
        });
    },
    updateClientDesignation() {
      const clientDesignationAPI =
        "/api/v1/crm/client-designation/" + this.formValues.id + "/";
      this.$axios
        .$patch(clientDesignationAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated client designation!`,
            color: "green"
          });
          this.$emit("clientDeisgnationFormResponse", "updated");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
          this.$store.dispatch("shell/showSnackbar", {
            text: error.response.data.field_errors[0],
            color: "red"
          });
        });
    },
    clearFields() {
      this.formValues.name = "";
      this.formValidator.setError({});
    }
  }
};
</script>
